import { Controller } from '@hotwired/stimulus';
import consumer from '../../channels/consumer';

// A floor, not a delay: the clock starts when the screen appears, so the wait
// it imposes is only what the server did not already spend. Processing the
// intention takes 0.6s at the median, which is a flicker to read.
const MINIMUM_DISPLAY = 3000;

export default class extends Controller {
  static targets = ['pending', 'failure', 'error'];

  static values = { id: String };

  connect() {
    if (!this.hasIdValue) return;

    this.shownAt = performance.now();

    this.channel = consumer.subscriptions.create(
      {
        channel: 'SubscriptionIntentionChannel',
        subscription_intention_id: this.idValue,
      },
      {
        received: (data) => this.#receive(data),
        rejected: () => this.#showError(),
      }
    );
  }

  disconnect() {
    clearTimeout(this.holdTimer);
    this.channel?.unsubscribe();
  }

  #receive(data) {
    try {
      if (data.status === 'success') {
        this.#onceRead(() => {
          window.location.href = data.next_step_path;
        });
      } else if (data.status === 'failure') {
        this.#onceRead(() => this.#reveal(this.failureTarget));
      } else {
        this.#showError();
      }
    } catch {
      this.#showError();
    }
  }

  #showError() {
    this.#onceRead(() => this.#reveal(this.errorTarget));
  }

  #onceRead(leave) {
    const remaining = MINIMUM_DISPLAY - (performance.now() - this.shownAt);

    if (remaining <= 0) {
      leave();
      return;
    }

    this.holdTimer = setTimeout(leave, remaining);
  }

  #reveal(screen) {
    this.pendingTarget.classList.add('d-none');
    screen.classList.remove('d-none');
  }
}
